import { Component, OnInit } from '@angular/core';
import { BackEndService } from 'src/app/services/backEnd.service';
import { BusinessService } from 'src/app/services/modelService/business.service';
import { TranslateService } from 'src/app/services/translate.service';
import { AlertService } from 'src/app/util/alert.service';
import { LoaderService } from 'src/app/util/loader.service';
import { ToastService } from 'src/app/util/toast.service';

@Component({
  selector: 'app-community-request',
  templateUrl: './community-request.component.html',
  styleUrls: ['./community-request.component.scss'],
  standalone: false,
})
export class CommunityRequestComponent implements OnInit {

  constructor(private toast: ToastService,
    private loader: LoaderService,
    private alert: AlertService, private backEnd: BackEndService,
    public businessService: BusinessService,
    public trans: TranslateService) { }

  ngOnInit() { }

  saveBusiness() {
    if (!this.businessService.business_request.name) {
      this.toast.warning(this.trans.translate('Please enter your name'));
      return;
    }
    if (!this.businessService.business_request.community_name || this.businessService.business_request.community_name.trim() == "") {
      this.toast.warning(this.trans.translate('Please enter community name'));
      return;
    }
    if (!this.businessService.business_request.mobile) {
      this.toast.warning(this.trans.translate('Please enter mobile number'));
      return;
    }
    if (!this.businessService.business_request.sub_community) {
      this.toast.warning(this.trans.translate('Please add sub community or Gotra'));
      return;
    }
    console.log(this.businessService.business_request);
    this.loader.show();

    this.toast.success("Your request has been sent");
    this.backEnd.saveObject("business_request", this.businessService.business_request).then(() => {

    });
    this.loader.hide();

  }

  addSubCommunity(name?: string) {
    this.alert.showTextAlert('Add Sub community', null, 'Name', 'Add', null, name).then((value: string) => {
      if (value) {
        if (this.businessService.business_request.sub_community == null) {
          this.businessService.business_request.sub_community = [];
        }
        if (!name) {
          this.businessService.business_request.sub_community.push(value);
        } else {
          this.businessService.business_request.sub_community = this.businessService.business_request.sub_community.map(str => str === name ? value : str);
        }
      } else {
        this.toast.warning('Please enter a name');
        this.addSubCommunity(name);
      }
    })
  }

  removeSubCommunity(name: string) {
    let index = this.businessService.business_request.sub_community.indexOf(name);
    if (index > -1) {
      this.businessService.business_request.sub_community.splice(index, 1);
    }
  }
  cancelBusiness() {
    this.businessService.business_request = null;
  }

}
